class HeroSlider extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.hero-slider__slide'));
    if (this.slides.length <= 1) return;

    this.dots = Array.from(this.querySelectorAll('.hero-slider__dot'));
    this.prevBtn = this.querySelector('.hero-slider__arrow--prev');
    this.nextBtn = this.querySelector('.hero-slider__arrow--next');
    this.current = 0;
    this.autoplay = this.dataset.autoplay === 'true';
    this.autoplaySpeed = parseInt(this.dataset.autoplaySpeed, 10) || 6000;

    this.prevBtn?.addEventListener('click', () => this.go(this.current - 1));
    this.nextBtn?.addEventListener('click', () => this.go(this.current + 1));
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.go(index));
    });

    this.addEventListener('mouseenter', () => this.stopAutoplay());
    this.addEventListener('mouseleave', () => this.startAutoplay());

    this.addSwipeSupport();
    this.startAutoplay();
  }

  go(index) {
    const total = this.slides.length;
    this.current = (index + total) % total;

    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === this.current);
    });
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.current);
    });
  }

  startAutoplay() {
    if (!this.autoplay) return;
    this.stopAutoplay();
    this.timer = setInterval(() => this.go(this.current + 1), this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.timer) clearInterval(this.timer);
  }

  addSwipeSupport() {
    let startX = 0;
    this.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
    }, { passive: true });

    this.addEventListener('touchend', (e) => {
      const endX = e.changedTouches[0].clientX;
      const diff = startX - endX;
      if (Math.abs(diff) > 40) {
        this.go(diff > 0 ? this.current + 1 : this.current - 1);
      }
    }, { passive: true });
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }
}

customElements.define('hero-slider', HeroSlider);

document.querySelectorAll('.hero-slider').forEach((el) => {
  if (!el.closest('hero-slider')) {
    const wrapper = document.createElement('hero-slider');
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  }
});